module.exports = __webpack_public_path__ + "static/media/2.f7537e98.svg";